import { getHeader, getAxiosUrl } from 'helpers';
import api from 'config/api.js';
import axios from 'axios';
const headers = getHeader();

export const save = async (review) => {
    try {
        const url = getAxiosUrl(api.path.review);
        const response = await axios.post(url, review, { headers });
        return response.data;
    } catch (error) {
        return null;
    }
};

export const getList = async ({ page }) => {
    try {
        const params = {
            page: page || 1,
        };
        const url = getAxiosUrl(api.path.review);
        const response = await axios.get(url, { params });

        return response.data;
    } catch (error) {
        return error;
    }
};
